const DpoCoreObdobi = {
    init: function () {
        const dotacnititul = $("#dotacnititul");
        if (!dotacnititul.length) {
            return;
        }

        dotacnititul
            .off("change")
            .on("change", function () {
                let url = window.location.protocol + "//" + window.location.host;
                url += "/ajax/core/nacteniObdobi";

                const sekceId = $('#idSection').val();
                if (!sekceId) {
                    return;
                }
                url += '/' + sekceId;

                const zadostId = $('#idItem').val();
                if (zadostId) {
                    url += '/' + zadostId;
                }

                const _ch = $("#_ch");
                if (!_ch.length) {
                    return;
                }

                $.ajax({
                    type: "post",
                    url: url,
                    data: {"_ch": _ch.val(), "titulId": dotacnititul.val()},
                    dataType: "json",
                    global: true,
                    beforeSend: function() {
                        Lemo_Alert.closeAll();
                    },
                    complete: function() {
                        DynaCore_Item.miniformReload(109, 10);
                    },
                    success: function(r) {
                        if (r.hasOwnProperty("messages")) {
                            Lemo_Alert.addMany(r.messages);
                        }

                        // setTimeout(function(){ location.reload(); }, 3000);
                    },
                    error: function() {
                        Lemo_Alert.addDanger("Načtení období dle dotačního titulu selhalo..", "obdobiError");
                    }
                });

            });
    }
}

$(document).ready(function() {
    DpoCoreObdobi.init();
});
